import React from 'react';
import PropTypes from 'prop-types';
import './Hero.css';

const Hero = props => {
    const { data } = props;

    return (
        <section className="hero" style={{ backgroundImage: `url(${data.path})` }}>
            <div className="hero-body">
                <div className="container">
                    <div className="columns">
                        <div className="column is-offset-1-tablet is-10-tablet is-11-desktop is-three-fifths-widescreen">
                            <div className="title-wrapper animated fadeInLeft">
                                {data.preTitle && <div className="pre-title">{data.preTitle}</div>}
                                {data.title && <h1 className="big-title">{data.title}</h1>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

Hero.propTypes = {
    data: PropTypes.object,
};

export default Hero;
